import { z } from 'zod';
export const MaxRecordsCustomCountSchema = z.object({
    maxRecords: z.coerce.number().int().positive(),
});
//# sourceMappingURL=schema.js.map